// 引入api请求方法
import { getDataReportInfoMonth } from '@/api/account';

const state = {
  // 接口调用参数
  postParams: {
    businessId: '', // 企业ID
    startDate: new Date(`${new Date().getFullYear()}-01-01 00:00:00`).getTime(), // 开票时间开始
    endDate: new Date(`${new Date().getFullYear()}-12-31 23:59:59`).getTime(), // 开票时间结束
    page: 1,
    size: 20,
  },
  staticticsData: null, // 统计data数据
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getStaticticsData: async context => {
    try {
      const { data } = await getDataReportInfoMonth({
        ...context.state.postParams,
      });
      context.commit('updateState', {
        key: 'staticticsData',
        value: Object.assign({}, context.state.staticticsData, data),
      });
    } catch (error) {
      console.error(error);
    }
  },
};

// mutations
const mutations = {
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 更新state
  updateState(state, { key, value }) {
    state[key] = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
